import deepEquals from 'fast-deep-equal';
import { useRef } from 'react';

export interface PropertyChangedReturn<T> {
  changed: boolean;
  previousValue: T | undefined;
}

const usePropertyChanged = <T>(property: T): PropertyChangedReturn<T> => {
  const lastValue = useRef<T>(undefined);
  let changed = false;

  if (lastValue.current !== undefined) {
    changed = !deepEquals(lastValue.current, property);
  }

  const returnValue: PropertyChangedReturn<T> = {
    changed,
    previousValue: lastValue.current,
  };

  lastValue.current = property;

  return returnValue;
};

export { usePropertyChanged };
